module.exports = __webpack_public_path__ + "d0c2bb89.png";